// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__27VS5","empty":"ModalGraph_empty__3Xqi0"};